import './../css/style.css';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { WCAG } from "rytm-wcag";
import { initAlpine } from './alpine';
import { initCommon } from './shared/common';
import { initHeaderNavBrand } from './shared/headerNavBrand';
import { initHeaderMobile } from './shared/headerMobile';
import { initListings } from './shared/listings';
import { initModvideo } from './shared/modvideo';
import { initEmailReveal } from './shared/emailReveal';
import { initModmap } from './shared/modmap';
import { initScrollTo } from './shared/scrollTo';
import { initMovieFooter } from './shared/movieFooter';
import { initBannerRotator } from './shared/bannerRotator';
import { initFormValidate } from './shared/formValidate';
import { initReCaptchaV3 } from './shared/reCaptchaV3';
import { initASwap } from './aswap';
import { initLoading } from './shared/loading';

gsap.registerPlugin(ScrollTrigger);

initAlpine();

const lenis = new Lenis({
  duration: 1,
  autoRaf: true,
});
(window as any).lenis = lenis;
lenis.on('scroll', ScrollTrigger.update);

WCAG.init();
initCommon();
initHeaderNavBrand();
initHeaderMobile();
initFormValidate();
initReCaptchaV3();
initListings();
initModvideo();
initEmailReveal();
initModmap();
initScrollTo();
initMovieFooter();
// Rotate the ad banner for THIS load (initial visit + every hard refresh) here,
// synchronously and under the loading curtain. ASwap's initial `onViewSwapComplete`
// only fires ~1.8s in (after the curtain lifts) — running it there caused a visible
// banner swap (flash) and let fast refreshes re-load before the cursor advanced.
// Doing it now picks the slide before first paint and advances the cursor on every
// load. The matching first `onViewSwapComplete` is skipped in aswap.ts (no double-
// advance); subsequent ASwap navigations rotate from that hook.
initBannerRotator();

// Run the initial-load reveal curtain once fonts are ready, and fire the ASwap
// init from within its timeline so the view's show animations sync with the
// curtain lifting (timing knob lives in shared/loading.ts).
document.fonts.ready.then(() => {
  initLoading(initASwap);
});